import NewNavbar from "./NewNavbar";
import Footer from "./Footer";
import { useState } from "react";
import axios from "axios";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import toast, { Toaster } from "react-hot-toast";

export default function GasMonitoring() {
  const images = [
    {
      id: 1,
      imageUrl:
        "http://res.cloudinary.com/dt8emxboh/image/upload/v1774856804/iissftnlfzglzija02cl.png",
    },
    {
      id: 2,
      imageUrl:
        "http://res.cloudinary.com/dt8emxboh/image/upload/v1774856837/r4pcjfjt58qsxpkvbdew.png",
    },
    {
      id: 3,
      imageUrl:
        "http://res.cloudinary.com/dt8emxboh/image/upload/v1774856864/zrm4shd86tkhvlrvofo0.png",
    },
  ];

  //Book a Demo call api

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Phone validation
    if (!/^\d{10}$/.test(formData.phone)) {
      toast.error("Phone number must be exactly 10 digits");
      return;
    }

    try {
      await axios.post("https://api.livestockify.com/api/admin/queries", {
        name: formData.firstName + " " + formData.lastName,
        phone: formData.phone,
        email: formData.email,
        message: formData.message,
      });

      toast.success("Message sent successfully ✅");

      // reset form
      setFormData({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong ❌");
    }
  };

  return (
    <>
      <NewNavbar />
      <Toaster position="top-right" reverseOrder={false} />

      <Carousel
        showThumbs={false}
        infiniteLoop={true}
        autoPlay={true}
        interval={3000}
        stopOnHover={true}
        dynamicHeight={true}
        showStatus={false}
        transitionTime={600}
        emulateTouch={true}
        swipeable={true}
        className="h-full"
      >
        {images.map((image) => (
          <div
            key={image.id}
            className="relative w-full h-[2x30px] md:h-[420px] lg:h-[550px] xl:h-[800px] 2xl:h-[850px]"
          >
            <img
              src={image.imageUrl}
              className="w-full h-full object-cover"
              alt={image.description || "carousel image"}
            />
          </div>
        ))}
      </Carousel>

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 leading-snug">
              Our <span className="text-[#6FAF1E]">Offerings</span> for Smart
              Gas & Sludge Monitoring{" "}
              <span className="text-[#0F6D73]">Solutions</span>
            </h2>

            <p className="text-gray-600 mt-4 text-sm md:text-base">
              Explore Kuppismart's intelligent IoT devices designed for
              real-time gas detection, sludge monitoring, and process
              intelligence. Our solutions integrate multi-parameter sensing,
              continuous connectivity, automation, and environmental tracking to
              ensure safe, efficient, and optimized operations in gas-generating
              environments.
            </p>
          </div>

          {/* Content */}
          <div className="grid md:grid-cols-2 gap-12 lg:gap-16 mt-16 items-center">
            {/* Left Image */}
            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772726771/cme0iywzd3dabez302cv.png"
                alt="Gas Monitoring Device"
                className="w-64 sm:w-72 md:w-80 lg:w-96 object-contain"
              />
            </div>

            {/* Right Content */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm md:text-base text-gray-700">
              {/* Column 1 */}
              <div>
                <h3 className="font-semibold text-[#0F6D73]">
                  Sensors Supported:
                </h3>
                <ul className="list-disc ml-5 mt-1 space-y-1">
                  <li>Ammonia (NH₃)</li>
                  <li>Methane (CH₄)</li>
                  <li>Optional: CO₂ / H₂S</li>
                  <li>Sludge pH</li>
                  <li>Sludge Temperature</li>
                  <li>Ambient Temperature</li>
                  <li>Humidity</li>
                </ul>

                <h3 className="font-semibold text-[#0F6D73] mt-4">
                  Monitoring:
                </h3>
                <ul className="list-disc ml-5 mt-1 space-y-1">
                  <li>Real-time gas concentration tracking</li>
                  <li>Sludge condition monitoring (pH & temperature)</li>
                  <li>Process tracking</li>
                  <li>Mobile app dashboard</li>
                </ul>

                <h3 className="font-semibold text-[#0F6D73] mt-4">
                  Connectivity:
                </h3>
                <ul className="list-disc ml-5 mt-1 space-y-1">
                  <li>Wi-Fi / Cellular (4G) / LoRa</li>
                  <li>Cloud data logging</li>
                  <li>Remote monitoring access</li>
                </ul>
              </div>

              {/* Column 2 */}
              <div>
                <h3 className="font-semibold text-[#0F6D73]">Alerts:</h3>
                <ul className="list-disc ml-5 mt-1 space-y-1">
                  <li>Instant gas leak / unsafe level alerts</li>
                  <li>Sludge condition alerts</li>
                  <li>App notifications</li>
                  <li>SMS / WhatsApp alerts</li>
                </ul>

                <h3 className="font-semibold text-[#0F6D73] mt-4">Power:</h3>
                <ul className="list-disc ml-5 mt-1 space-y-1">
                  <li>AC power</li>
                  <li>Solar compatible with battery backup</li>
                </ul>

                <h3 className="font-semibold text-[#0F6D73] mt-4">
                  Automation:
                </h3>
                <ul className="list-disc ml-5 mt-1 space-y-1">
                  <li>Ventilation & exhaust control</li>
                  <li>Rule-based and smart automation support</li>
                </ul>

                <h3 className="font-semibold text-[#0F6D73] mt-4">
                  Deployment:
                </h3>
                <ul className="list-disc ml-5 mt-1 space-y-1">
                  <li>Industrial gas environments</li>
                  <li>Waste processing units</li>
                  <li>Biogas / organic processing plants</li>
                  <li>Medium to large-scale setups</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold">
              Key{" "}
              <span className="text-[#6FAF1E]">Gas Monitoring Solutions</span>{" "}
              Powered by <span className="text-[#0F6D73]">Kuppismart</span>
            </h2>

            <p className="text-gray-600 mt-4 text-sm md:text-base">
              Kuppismart gas monitoring systems deliver real-time gas detection,
              process intelligence, and environmental monitoring, helping
              industries ensure safety, efficiency, and regulatory compliance.
              With cloud-native integration and smart automation, operations
              become predictive, not reactive.
            </p>
          </div>

          {/* Section 1 */}
          <div className="grid md:grid-cols-2 gap-12 items-center mt-16">
            {/* Text */}
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-semibold">
                <span className="text-[#6FAF1E]">Process Intelligence</span>{" "}
                (Material to Gas Tracking)
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                Track crushing / processing time to understand how materials
                convert into gases. This unique system provides early prediction
                of gas formation, helping operators take preventive measures
                before dangerous levels are reached.
              </p>
            </div>

            {/* Image */}
            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774626486/pziayyvirpmsglm71v8d.png"
                alt="Process Intelligence"
                className="w-[260px] md:w-[320px] lg:w-[380px] object-contain"
              />
            </div>
          </div>

          {/* Section 2 */}
          <div className="grid md:grid-cols-2 gap-12 items-center mt-20">
            {/* Image */}
            <div className="flex justify-center order-2 md:order-1">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774603480/xlfqxfffar1kdur7ee9e.png"
                alt="Multi Parameter Sensors"
                className="w-[260px] md:w-[320px] lg:w-[360px] object-contain"
              />
            </div>

            {/* Text */}
            <div className="text-center md:text-left order-1 md:order-2">
              <h3 className="text-xl md:text-2xl font-semibold">
                Multi-Parameter{" "}
                <span className="text-[#6FAF1E]">
                  Gas, Sludge & Environmental Monitoring
                </span>
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                Simultaneously monitor gas levels (NH₃, CH₄), optional CO₂, H₂S,
                temperature, humidity, pH levels in sludge, and sludge
                temperature. Kuppismart correlates gas concentration with
                environmental conditions, ensuring accurate insights and better
                safety control.
              </p>
            </div>
          </div>

          {/* Section 3 */}
          <div className="grid md:grid-cols-2 gap-12 items-center mt-20">
            {/* Text */}
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-semibold">
                <span className="text-[#6FAF1E]">Real-Time</span> Monitoring,
                Alerts & Cloud Insights
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                Kuppismart Gas Sense continuously tracks gas levels, sludge
                conditions (pH & temperature), and environmental factors like
                temperature and humidity, with AI data analytics on a
                centralized cloud dashboard. It provides instant alerts and
                smart insights, enabling proactive monitoring and improved
                safety management.
              </p>
            </div>

            {/* Image */}
            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772726888/ahj0tsfyafvyu027e0ih.png"
                alt="Mobile Monitoring App"
                className="w-[220px] md:w-[280px] lg:w-[320px] object-contain"
              />
            </div>
          </div>

          {/* Section 4 */}
          <div className="grid md:grid-cols-2 gap-12 items-center mt-20">
            {/* Image */}
            <div className="flex justify-center order-2 md:order-1">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774626804/nrwrqbluaxoyke314jyv.png"
                alt="Ventilation System"
                className="w-[260px] md:w-[320px] lg:w-[380px] object-contain"
              />
            </div>

            {/* Text */}
            <div className="text-center md:text-left order-1 md:order-2">
              <h3 className="text-xl md:text-2xl font-semibold">
                Ventilation & Safety{" "}
                <span className="text-[#6FAF1E]">Automation</span>
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                Automatically control exhaust systems, ventilation fans, and
                safety mechanisms based on real-time conditions. This reduces
                manual intervention while ensuring safe, efficient, and
                responsive operations.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold">
              Why Choose <span className="text-[#6FAF1E]">Gas Sense</span>
            </h2>

            <p className="text-gray-600 mt-4 text-sm md:text-base">
              Unlike generic wastewater monitoring systems, Kuppismart STP Sense
              combines real-time sensing, IoT automation, and compliance-focused
              analytics—helping industries maintain regulatory standards,
              optimize operations, and reduce manual intervention.
            </p>
          </div>

          {/* Table */}
          <div className="mt-14 overflow-x-auto">
            <table className="w-full min-w-[900px] border-collapse">
              {/* Table Head */}
              <thead>
                <tr className="text-center">
                  <th className="py-4 text-gray-700 text-2xl font-semibold">
                    Feature
                  </th>
                  <th className="py-4 text-[#6FAF1E] text-2xl font-semibold">
                    Gas Sense Pro
                  </th>
                  <th className="py-4 text-[#0F6D73] text-2xl font-semibold">
                    Gas Sense
                  </th>
                  <th className="py-4 text-gray-700 text-2xl font-semibold">
                    Typical Other System
                  </th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody className="text-sm md:text-base">
                <tr>
                  <td className="py-4 text-xl font-medium">Water Parameters</td>
                  <td className="text-[#6FAF1E] text-xl">
                    Ammonia (NH₃), Methane (CH₄), CO₂, H₂S
                  </td>
                  <td className="text-[#0F6D73] text-xl">
                    Ammonia (NH₃), Methane (CH₄)
                  </td>
                  <td className="text-xl">Single gas only</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Process Monitoring (Crushing Time)
                  </td>
                  <td className="text-[#6FAF1E] text-xl">
                    ✔ Real-time process tracking
                  </td>
                  <td className="text-[#0F6D73] text-xl">✔ Basic tracking</td>
                  <td className="text-xl">✖ Not available</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Material-to-Gas Conversion Insight
                  </td>
                  <td className="text-[#6FAF1E] text-xl">✔ Full analytics</td>
                  <td className="text-[#0F6D73] text-xl">Limited</td>
                  <td className="text-xl">✖ No visibility</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Temperature Monitoring (Environment)
                  </td>
                  <td className="text-[#6FAF1E] text-xl">✔ High precision</td>
                  <td className="text-[#0F6D73] text-xl">✔</td>
                  <td className="text-xl">Limited</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Humidity Monitoring
                  </td>
                  <td className="text-[#6FAF1E] text-xl">✔ Real-time</td>
                  <td className="text-[#0F6D73] text-xl">✔</td>
                  <td className="text-xl">✖ Not included</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Sludge pH Monitoring
                  </td>
                  <td className="text-[#6FAF1E] text-xl">
                    ✔ Continuous real-time
                  </td>
                  <td className="text-[#0F6D73] text-xl">✔ Available</td>
                  <td className="text-xl">✖ Not included</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Sludge Temperature Monitoring
                  </td>
                  <td className="text-[#6FAF1E] text-xl">
                    ✔ Real-time tracking
                  </td>
                  <td className="text-[#0F6D73] text-xl">✔ Available</td>
                  <td className="text-xl">✖ Not included</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Real-Time Gas Detection
                  </td>
                  <td className="text-[#6FAF1E] text-xl">
                    ✔ Continuous + alerts
                  </td>
                  <td className="text-[#0F6D73] text-xl">✔ Continuous</td>
                  <td className="text-xl">Limited</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">Safety Alerts</td>
                  <td className="text-[#6FAF1E] text-xl">
                    AI-based + threshold alerts
                  </td>
                  <td className="text-[#0F6D73] text-xl">Threshold alerts</td>
                  <td className="text-xl">Basic alarms</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Automation (Ventilation / Exhaust)
                  </td>
                  <td className="text-[#6FAF1E] text-xl">✔ Smart control</td>
                  <td className="text-[#0F6D73] text-xl">✔ Rule-based</td>
                  <td className="text-xl">✖ Manual</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">Cloud Dashboard</td>
                  <td className="text-[#6FAF1E] text-xl">
                    ✔ Advanced analytics
                  </td>
                  <td className="text-[#0F6D73] text-xl">✔ Standard</td>
                  <td className="text-xl">Limited</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Dual Device Integration
                  </td>
                  <td className="text-[#6FAF1E] text-xl">
                    ✔ Process + Gas synced
                  </td>
                  <td className="text-[#0F6D73] text-xl">Partial</td>
                  <td className="text-xl">✖ Single device only</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">Sensor Expansion</td>
                  <td className="text-[#6FAF1E] text-xl">
                    ✔ Multi-gas scalable
                  </td>
                  <td className="text-[#0F6D73] text-xl">Limited</td>
                  <td className="text-xl">Fixed</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">Connectivity</td>
                  <td className="text-[#6FAF1E] text-xl">Wi-Fi / 4G / LoRa</td>
                  <td className="text-[#0F6D73] text-xl">Wi-Fi / 4G</td>
                  <td className="text-xl">Wi-Fi only</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">Installation</td>
                  <td className="text-[#6FAF1E] text-xl">Plug & deploy</td>
                  <td className="text-[#0F6D73] text-xl">Easy install</td>
                  <td className="text-xl">Complex</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Industrial Safety Compliance
                  </td>
                  <td className="text-[#6FAF1E] text-xl">✔ Safety-ready</td>
                  <td className="text-[#0F6D73] text-xl">✔ Basic</td>
                  <td className="text-xl">Limited</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Data Logging & Reports
                  </td>
                  <td className="text-[#6FAF1E] text-xl">
                    ✔ Automated reports
                  </td>
                  <td className="text-[#0F6D73] text-xl">✔ Basic</td>
                  <td className="text-xl">Manual</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">Scalability</td>
                  <td className="text-[#6FAF1E] text-xl">
                    Industrial / Large plants
                  </td>
                  <td className="text-[#0F6D73] text-xl">Medium setups</td>
                  <td className="text-xl">Small only</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ================= BOOK DEMO SECTION ================= */}
        <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center md:text-left">
            <h2 className="text-4xl md:text-5xl font-bold">
              Book a <span className="text-[#6FAF1E]">Demo</span> Today
            </h2>

            <p className="text-gray-600 mt-6 text-lg max-w-md mx-auto md:mx-0">
              Book a Demo today to discover how Kuppismart can optimise your
              farm with IoT and AI technologies.
            </p>
          </div>

          {/* Form Card */}
          <div className="bg-white p-8 rounded-xl shadow-md">
            <form onSubmit={handleSubmit} className="space-y-5">
              {/* Name Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-start font-medium mb-1">
                    First Name
                  </label>
                 

                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Enter Your First Name"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>

                <div>
                  <label className="block text-start font-medium mb-1">
                    Last Name
                  </label>
                

                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Enter Your Last Name"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Contact Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-start font-medium mb-1">
                    Phone Number
                  </label>
                 

                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter Your Phone Number"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>

                <div>
                  <label className="block text-start font-medium mb-1">
                    Email-ID
                  </label>
                

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Your Email-ID"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Message */}
              <div>
                <label className="block text-start font-medium mb-1">
                  How can we help you?
                </label>
            

                <textarea
                  rows="4"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter Your Message"
                  required
                  className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Button */}
              <button
                type="submit"
                className="w-full bg-green-600 text-white py-3 rounded-md font-medium hover:bg-green-700 transition"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
